/**
 * trida pro praci s geolokaci skrze Promise
 */
export default new class {

  constructor () {
    this.latitude  = null
    this.longitude = null

    this.locationPromise = new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude  = position.coords.latitude
        this.longitude = position.coords.longitude

        resolve()
      }, () => {
        resolve()
      })
    })
  }

  /**
   *
   * @type {Promise<any>}
   */
  getPromise () {
    return this.locationPromise
  }

  /**
   *
   * @return {null|*|number}
   */
  getLatitude () {
    return this.latitude
  }

  /**
   *
   * @return {null|*|number}
   */
  getLongitude () {
    return this.longitude
  }

  /**
   *
   * @param args
   * @private
   */
  extendArgs (args) {
    args.CURRENTLONGITUDE = this.getLongitude()
    args.CURRENTLATITUDE  = this.getLatitude()
  }

  /**
   *
   * @param params
   * @return {*}
   * @private
   */
  extendParams (params) {
    if (!this.getLatitude() || !this.getLongitude()) {
      return params
    }

    if (params === '?') {
      params += 'CURRENTLONGITUDE=' + this.getLongitude()
      params += '&CURRENTLATITUDE=' + this.getLatitude()
    }
    else {
      params += '&CURRENTLONGITUDE=' + this.getLongitude()
      params += '&CURRENTLATITUDE=' + this.getLatitude()
    }

    return params
  }

}